import { BranchForkRegular, DocumentSearchRegular, ArrowTrendingRegular } from '@fluentui/react-icons'
import { CapabilityCard } from '@/components/common/CapabilityCard'
import { PanelShell } from './PanelShell'
import grid from './PanelGrid.module.css'

interface PanelProps {
  onOpenWorkspace: () => void
}

export function AttackPathPanel({ onOpenWorkspace }: PanelProps) {
  return (
    <PanelShell
      icon={BranchForkRegular}
      title="Attack Path"
      subtitle="Correlate identity, endpoint and incident evidence to reconstruct the most probable attack path."
      onOpenWorkspace={onOpenWorkspace}
    >
      <div className={grid.grid}>
        <CapabilityCard
          icon={BranchForkRegular}
          eyebrow="Reconstruction"
          title="Probable attack path"
          points={[
            'Chains related identity, endpoint and incident signals into a candidate sequence of events',
          ]}
        />
        <CapabilityCard
          icon={ArrowTrendingRegular}
          eyebrow="Correlation"
          title="Cross-domain correlation"
          points={['Identity × Endpoint × Incident correlation']}
        />
        <CapabilityCard
          icon={DocumentSearchRegular}
          eyebrow="Transparency"
          title="Confidence, not certainty"
          points={[
            'Attack paths are analyst-grade hypotheses grounded in available evidence, not confirmed findings',
          ]}
        />
      </div>
    </PanelShell>
  )
}
